import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {SESSION_STORAGE, StorageService} from 'ngx-webstorage-service';
import {AlertService} from 'ngx-alerts';
import {environment} from '../../../environments/environment';
import {CommonService} from '../../core/services/common.service';
import {apiConfig} from '../../api-url.config';
import {catchError, map} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DrivingSchoolService extends CommonService {
  API_END_POINT: string;

  constructor(private httpClient: HttpClient, private spinner: NgxSpinnerService,
              private alertService: AlertService,) {
    super();
    this.API_END_POINT = environment.API_SERVER;
  }

  getUserReferrals(userId: string) {
    return this.httpClient.get(`${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.referrals}`, {})
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  getUserDetails(userId: string, search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient.get(`${this.API_END_POINT}${apiConfig.user}/${userId}`, {params})
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  addUpdateBusinessProfileDetails(userId: any, payload: any) {
    return this.httpClient.post(`${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.businessProfile}`, payload)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  getUserOrderCommissions(userId: string) {
    return this.httpClient.get(`${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.orderCommissions}`, {})
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  getUserBankDetails(userId: string) {
    return this.httpClient.get(`${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.accountDetails}`, {})
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  addUpdateUserBankDetails(userId: any, value: any) {
    return this.httpClient.post(`${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.accountDetailsAddUpdate}`, value)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }
}
